import { Method } from 'axios';
import { Executable } from '../executable';
import { ILinkActivation, ILinkActivationAttribute, ILinkActivationInput } from '..';

/**
 * The CreateLinkActivation creates an activation link for a program to issue cards with.
 */
export class CreateLinkActivation
  extends Executable<ILinkActivation>
  implements Partial<ILinkActivationInput>
{
  public name?: string;

  public brandId?: number;

  public tenantId?: number;

  public programId?: number;

  public endDate?: Date | string;

  public templateTierId?: number;

  public attributes?: ILinkActivationAttribute[];

  public captchaEnabled?: boolean | undefined;

  public passesLimit?: number | undefined;

  public getMethod(): Method {
    return 'post';
  }

  public getResponse(apiResponse: any): ILinkActivation {
    return apiResponse;
  }

  public getURLPath(tenantId?: string): string {
    if (!this.brandId) throw new Error('brandId is required');
    if (!this.programId) throw new Error('programId is required');
    return `/${this.brandId}/programs/${this.programId}/link-activations`;
  }

  constructor(input?: Partial<ILinkActivationInput>) {
    super();
    if (input) {
      Object.assign(this, input);
    }
  }

  /**
   * getBody is used by the BambuClient to properly construct the request object body.
   * @returns Returns the expected body of the request utilizing the defined request attributes.
   */
  getBody(): Partial<ILinkActivationInput> & { tenantId: number; name: string } {
    if (!this.tenantId) throw new Error('tenantId is required');
    if (!this.name) throw new Error('name is required');
    if (!this.brandId) throw new Error('brandId is required');
    if (!this.programId) throw new Error('programId is required');
    return {
      tenantId: this.tenantId,
      brandId: this.brandId,
      programId: this.programId,
      name: this.name,
      endDate: this.endDate,
      templateTierId: this.templateTierId,
      attributes: this.attributes || undefined,
      captchaEnabled: this.captchaEnabled || false,
      passesLimit: this.passesLimit || 0,
    };
  }

  /**
   * getRootPath is used by the BambuClient to properly construct the request call.
   * @returns The root path of the request
   */
  getRootPath(): string | undefined {
    return 'brands';
  }
}
